// extracted by mini-css-extract-plugin
module.exports = {"root":"EventCalendarDayHours_root__YlJ6K","back":"EventCalendarDayHours_back__F0niy","title":"EventCalendarDayHours_title__dVZcy","items":"EventCalendarDayHours_items__uRHOg"};